import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import DatePickerYear from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import AgTable from '../../../Components/Table/AgTable';

export default function VentasGeneral({ title }) {

    const token = useGetToken();

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();
    const [inflacion, setInflacion] = useState(false)
    const [condition, setCondition] = useState(false)


    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for ChartFromServer
        setUnidadEconomica(inputValue);
    }

    const onChangeInflacion = () => {
        setInflacion(!inflacion);
        setCondition(true)
    }


    const [dateMes, setDateMes] = useState(new Date());
    const [dateMesTemp, setDateMesTemp] = useState(new Date());
    let dateFormatedMes = (dateMes) ? (dateMes.getMonth() + 1) : (dateMesTemp.getMonth() + 1);

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    const [año1, setAño1] = useState(new Date());
    let dateFormated1 = año1.getFullYear();
    let previousYear = dateFormated1 - 1

    const [año2, setAño2] = useState(new Date(Utilities.getAnioComparativo(), month, day));
    let dateFormated2 = año2.getFullYear();

    registerLocale('es', es);

    const header = [
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Denominación Contrato',
            field: 'denominacion',
        }
    ]

    Utilities.monthNames.forEach(function (monthFullName, index, array) {
        if (index === (dateFormatedMes - 1)) {
            header.push({
                headerComponent: () => (<div>Venta  <br></br><span className=' fs-8'>{monthFullName + " " + dateFormated1}</span></div>),
                field: 'ventasAnio1',
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data.ventasAnio1, true, 2)}</>
                )
            })
            header.push({
                headerComponent: () => (<div>Venta  <br></br><span className=' fs-8'>{monthFullName + " " + dateFormated2}</span></div>),
                field: 'ventasAnio2',
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data.ventasAnio2, true, 2)}</>
                )
            })
            header.push({
                headerComponent: () => (<div>Presupuesto   <br></br><span className=' fs-8'>{monthFullName + " " + dateFormated1}</span></div>),
                field: 'presupuestoAnio1',
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data.presupuestoAnio1, true, 2)}</>
                )
            })
            header.push({
                headerComponent: () => (<div>Presupuesto  <br></br><span className=' fs-8'>{monthFullName + " " + dateFormated2}</span></div>),
                field: 'presupuestoAnio2',
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data.presupuestoAnio2, true, 2)}</>
                )
            })
            header.push({
                headerComponent: () => (<div>Dif Venta vs Presupuesto <br></br><span className=' fs-8'>{`${monthFullName} ${dateFormated1}`}</span></div>),
                field: 'diferenciaValor',
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data.diferenciaValor, true, 2)}</>
                )
            })
            header.push({
                headerComponent: () => (<div>% <br></br><span className=' fs-8'>{monthFullName}</span></div>),
                field: 'diferenciaPorcentaje',
                type: 'rightAligned',
                cellRenderer: (props) => (
                    <>{Utilities.comillasFix(props.data.diferenciaPorcentaje, true, 2)}</>
                )
            })
        }
    });
    const [startDate, setStartDate] = useState(null);
    const [value, onChange] = useState(new Date());
    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.VENTAS_PRESUPUESTO]} >
                <PageTitle>{title}</PageTitle>
                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row flex-wrap d-flex flex-row">

                        <div className="col-12 col-sm-6 col-md-3">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeGraphType)}
                            />
                        </div>
                        <div className="col-12 col-sm-6 col-md-3">
                            <div className='p-2 form-check inflacion form-switch form-switch-sm form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    name='inflacion'
                                    defaultChecked={false}
                                    onChange={(onChangeInflacion)}
                                />
                                <label className='form-check-label'>Inflación</label>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-3'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mes de Reporte:</div>
                            <DatePickerYear
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={dateMes}
                                onChange={(dateX) => {
                                    setDateMes(dateX)
                                    if(dateX) {
                                        setDateMesTemp(dateX)
                                        setAño1(dateX)
                                    }
                                }}
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                                maxDate={new Date()}
                            />
                        </div>
                        <div className='col-12 col-sm-6 col-md-3'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                            <DatePickerYear
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={año2}
                                onChange={(dateX) => dateX && setAño2(dateX)}
                                dateFormat="yyyy"
                                showYearPicker
                                minDate={Utilities.add_years(new Date(), -6)}
                                maxDate={new Date()}
                            />
                        </div>
                    </div>
                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"VentasGeneralPresupuesto" + + unidadEconomica.value + inflacion + " " + dateFormatedMes + " " + dateFormated1 + " " + dateFormated2}
                            apiService={Api.VentasGeneralPresupuesto}
                            setAuxData={null}
                            header={header}
                            titleExcel={"Reporte General de Ventas vs Presupuesto " + unidadEconomica.value + " - Inflacion: " + inflacion + " " + dateFormatedMes + " " + dateFormated1 + " " + dateFormated2}
                            conditions={true || condition}
                            args={{ unidadEconomicaId: unidadEconomica.value, inflacion: inflacion, mes: dateFormatedMes, anio1: dateFormated1, anio2: dateFormated2, token: useGetToken() }}
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            updateCondition={setCondition}
                            useFlex={false}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}